import { FUNCTIONS_URL as BASE, SUPABASE_ANON_KEY } from "@/lib/backend";

const FUNCTIONS_URL = `${BASE}/daily-puzzle`;
const ANON_KEY = SUPABASE_ANON_KEY;

export async function fetchDailyPuzzle<T>(
  game: "word-drill" | "group-sort",
  date: string,
): Promise<T | null> {
  try {
    const res = await fetch(`${FUNCTIONS_URL}?game=${game}&date=${date}`, {
      headers: { apikey: ANON_KEY, Authorization: `Bearer ${ANON_KEY}` },
    });
    if (!res.ok) {
      console.error(`daily-puzzle ${game} failed [${res.status}]: ${await res.text()}`);
      return null;
    }
    return (await res.json()) as T;
  } catch (error) {
    console.error(`daily-puzzle ${game} request error:`, error);
    return null;
  }
}